import React from 'react';
import { motion } from 'motion/react';
import { getRevealProps } from '../motion/scrollMotion';
import ScrollReveal from './ScrollReveal';
import './AIWorkflowsSection.css';

const AIWorkflowsSection = () => {
  return (
    <ScrollReveal as="section" className="ai-workflows-section" variant="fadeUp">
      <div className="aiw-container">
        <motion.div className="aiw-visual" {...getRevealProps('slideLeft')}>
          <div className="aiw-dashboard-frame">
            <div className="aiw-glow-top"></div>
            <div className="aiw-glow-left"></div>
            <img
              src="/secops.png.png"
              alt="AI Workflows Dashboard"
              className="aiw-dashboard-img"
            />
            <div className="aiw-visual-overlay">
              <div className="aiw-visual-logo">SECOPS</div>
              <div className="aiw-visual-sub">24/7 Security Operations Center</div>
            </div>
          </div>
        </motion.div>

        <motion.div className="aiw-content" {...getRevealProps('slideRight', 0.12)}>
          <span className="aiw-badge">Security Operations</span>
          <h2 className="aiw-title">
            Security Operations Built<br />
            for Immediate Response
          </h2>

          <div className="aiw-description">
            <p>
              Our 24/7 Security Operations Center integrates with your SIEM, SOAR, EDR, and
              XDR tooling — correlating signals across your endpoints, network, cloud, and
              identity so nothing slips through the cracks.
            </p>
            <p>
              The moment our analysts confirm a real threat, guided playbooks drive rapid
              containment and a ticket is raised instantly — giving your team immediate,
              analyst-coordinated response instead of endless alert fatigue.
            </p>
          </div>
        </motion.div>
      </div>
    </ScrollReveal>
  );
};

export default AIWorkflowsSection;
